import {Box, VStack, HStack, Avatar, Text, Flex, Image} from '@chakra-ui/react'
import AvatarDefault from '@assets/images/avatar-msg-part-two.png'
import Volume1Image from '@assets/images/volume_1.png'
import SuggestionItem from './SuggestionItem'
import {useDispatch} from 'react-redux'
import {updateAudio} from '@redux/learn-part-two/learnPartTwo'

const SuggestionMsg = ({msg}: {msg: any}) => {
  const dispatch = useDispatch()

  const handlePlayAudio = () => {
    const audioData = {
      time: Date.now(),
      url: msg?.data?.audio,
    }
    dispatch(updateAudio(audioData))
  }

  return (
    <HStack align="start" spacing={4}>
      <Avatar
        src={AvatarDefault}
        size="sm"
        borderRadius={'50%'}
        border={'2px solid #E4E7EC'}
      />
      <VStack
        maxWidth={'80%'}
        align="start"
        spacing={4}
        flex={1}
        bg={'white'}
        p={'16px'}
        borderRadius={'12px'}>
        <Text fontWeight="600" fontSize={'16px'}>
          Câu đề xuất
        </Text>
        <Flex bg="blue.50" p={4} borderRadius="xl" width="100%" gap={'10px'}>
          <Image
            src={Volume1Image}
            w={'56px'}
            h={'56px'}
            cursor={'pointer'}
            onClick={handlePlayAudio}
          />
          <Text color="blue.600" fontSize={'16px'}>
            {msg?.data?.text}
          </Text>
        </Flex>
        <Box>
          <Text mb={2} fontWeight="600" fontSize={'16px'}>
            Nâng cấp cho bạn nè!
          </Text>
          <VStack align="stretch" spacing={4}>
            {msg?.data?.chat_gpt_suggestion?.message?.improvement?.map(
              (suggestion: any, i: number) => (
                <SuggestionItem key={i} suggestion={suggestion} />
              ),
            )}
          </VStack>
        </Box>
      </VStack>
    </HStack>
  )
}

export default SuggestionMsg
